module.exports = __webpack_public_path__ + "img/va.4ddc5dbc.svg";